import { useMemo, useState } from "react";
import { useSolicitudesCurso } from "../solicitudes-en-curso/useSolicitudesCurso";
import { modalEjecutar, modalCargando, mensajeSimple } from "../../components/ui/sweetAlerts";
import { createFetchTableData } from "../../utils/createFetchTableData";
import { faEye, faTrashAlt } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { deleteWithResponse } from "../../api/apis";
import Swal from "sweetalert2";

export const useSolicitudesAdministrador = () => {
  const { hideModal, objModal, objModalAdmin, visible, setVisible, setdataModal, verificarPermisosCancelar } = useSolicitudesCurso();
  const [selectedRows, setSelectedRows] = useState([]);
  const [refreshToggle, setRefreshToggle] = useState(0);
  const [puedeEliminar, setPuedeEliminar] = useState(undefined);
  const idPerfil = localStorage.getItem("id_perfil");

  const refreshTable = () => setRefreshToggle((prev) => prev + 1);

  const filtrosPorPerfil = useMemo(() => {
    let params = {};

    switch (idPerfil) {
      case "3":
        params.id_estado_solicitud = "2"; // en curso
        params.id_tipo_solicitud = ""; // cuando esta vacio obtiene todas las solicitudes
        break;
      case "4":
        params.id_estado_solicitud = "1"; // todas las solicitudes en curso
        params.id_tipo_solicitud = ""; // cuando esta vacio obtiene todas las solicitudes
        params.creadas_por_mi = true;
        break;
      default:
        // Otros perfiles pueden agregarse como nuevos "case" aquí
        break;
    }

    // Validar y limpiar: eliminamos las propiedades que estén vacías, nulas o indefinidas
    Object.keys(params).forEach(key => {
      if (params[key] === "" || params[key] === null || params[key] === undefined) {
        delete params[key];
      }
    });

    return params;
  }, [idPerfil]);

  const fetchTableData = useMemo(
    () =>
      createFetchTableData({
        url: "cc/solicitudes_paginadas",
        initialSortBy: "fecha_inicio_cambio",
        initialSortDir: "desc",
        extraParams: filtrosPorPerfil,
      }),
    [filtrosPorPerfil],
  );

  // const ENDPOINT_APROBAR = 'cc/aprobar_masivo'; // este no existe
  // const ENDPOINT_RECHAZAR = 'cc/rechazar_masivo'; // este tampoco existe

  const handleAprobarGrupo = (selected) => {
    alert(`aprobar grupo ${selected}`);
  };

  const handleRechazarGrupo = (selected) => {
    alert(`rechazar grupo ${selected}`);
  };

  const eliminarSolicitudInicial = async (id) => {
    Swal.close();
    modalCargando("Eliminando solicitud...");
    try {
      const resp = await deleteWithResponse("cancelarsolicitud", null, { id_solicitud: id });

      if ([200].includes(resp?.status)) {
        mensajeSimple('success', 'Solicitud eliminada correctamente', 2500);
        setTimeout(() => {
          document.querySelector("button.btn-close.btn-close-white").click();
          refreshTable();
        }, 2000);
      }
      else {
        mensajeSimple('error', 'No fue posible eliminar la solicitud', 2500);
      }


    } catch (error) {
      console.log("Error al eliminar la solicitud:", error);
      Swal.fire({
        icon: 'error',
        title: 'Error',
        text: 'Ocurrió un error al eliminar la solicitud.',
      });
    }


  }


  const verPermiso = async (id) => {
    const resp = await verificarPermisosCancelar(id);
    setPuedeEliminar(resp.puede_eliminar);
  }


  const columnsDef = [
    {
      key: "id",
      label: "ID Solicitud",
      sortable: true,
      searchable: true,
      isVisible: false,
      render: (_, row) => row.id,
    },
    {
      key: "colaborador",
      label: "Colaborador",
      sortable: true,
      searchable: true,
      minWidth: "250px",
      render: (_, row) => `${row.persona?.nombre || ""} ${row.persona?.apellido_pat || ""} ${row.persona?.apellido_mat || ""}`.trim(),
    },
    {
      key: "rut",
      label: "RUT",
      sortable: true,
      searchable: true,
      minWidth: "90px",
      render: (_, row) => row.persona?.identificacion || "",
    },
    {
      key: "instalacion_actual",
      label: "Instalación de origen",
      sortable: true,
      searchable: true,
      render: (_, row) => row.instalacion_actual || "No Aplica",
    },
    {
      key: "nombre_cargo_actual",
      label: "Cargo actual",
      sortable: true,
      searchable: true,
      render: (_, row) => (row.nombre_cargo_actual ? row.nombre_cargo_actual.split("|")[1] || row.nombre_cargo_actual : ""),
    },
    {
      key: "descripcion_unidad_temporis",
      label: "Nuevo Cargo Temporis",
      sortable: true,
      searchable: true,
      render: (_, row) => (row.descripcion_unidad_temporis ? row.descripcion_unidad_temporis.split(" - ")[1] || row.descripcion_unidad_temporis : ""),
    },
    {
      key: "fecha_inicio_cambio",
      label: "Fecha inicio cambio",
      sortable: true,
      searchable: true,
      type: "date",
      minWidth: "90px",
    },
    {
      key: "tipo_solicitud",
      label: "Tipo solicitud",
      sortable: true,
      searchable: true,
      render: (_, row) => row.tipo_solicitud_cambio_contraactual?.nombre || "",
    },
    {
      key: "estado",
      label: "Estado actual",
      headerAlign: "left",
      sortable: true,
      searchable: false,
      render: (_, row) => row.estado_solicitud_cambio_contractual?.nombre || "",
    },
    {
      key: "acciones",
      label: "Acciones",
      stickyRight: true,
      sortable: false,
      searchable: false,
      headerAlign: "center",
      dataAlign: "center",
      minWidth: "100px",
      render: (_, row) => (
        <button className="btn btn-light px-3 py-1 fw-bold rounded-pill d-flex align-items-center shadow-sm transition-all" style={{ color: "#2a77b9", border: "1px solid #cce0f0" }} title="Ver solicitud"
          onClick={() => {
            setdataModal(row);
            setVisible(true);
          }}
        >
          Ver <FontAwesomeIcon className="ms-1" icon={faEye} />
        </button>
      ),
    },
  ];


  return {
    filtrosPorPerfil,
    fetchTableData,
    columnsDef,
    selectedRows,
    setSelectedRows,
    handleAprobarGrupo,
    handleRechazarGrupo,
    visible,
    hideModal,
    objModal,
    objModalAdmin,
    refreshToggle,
    verPermiso,
    puedeEliminar,
    eliminarSolicitudInicial,
  };
};
